import { devtools, persist } from 'zustand/middleware';
import { createWithEqualityFn } from 'zustand/traditional';

type TCustomer = {
  email: string;
  first_name: string;
  last_name: string;
  phone: string;
  address: string;
  area: string;
  area_id: string;
  pinpoint: {
    lat: string;
    lng: string;
  };
};

type TCommons = {
  customer: TCustomer;
  setCustomer: (customer: TCustomer) => void;
  clearCustomer: () => void;
};

export const useCustomerStore = createWithEqualityFn<TCommons>()(
  devtools(
    persist(
      (set) => ({
        customer: {
          email: '',
          first_name: '',
          last_name: '',
          phone: '',
          address: '',
          area: '',
          area_id: '',
          pinpoint: {
            lat: '',
            lng: '',
          },
        },
        isSelectedShipping: false,
        isSelectedShippingInsurance: false,
        setCustomer: (customer) => set({ customer }),
        clearCustomer: () =>
          set({
            customer: {
              email: '',
              first_name: '',
              last_name: '',
              phone: '',
              address: '',
              area: '',
              area_id: '',
              pinpoint: {
                lat: '',
                lng: '',
              },
            },
          }),
      }),
      { name: '@jstore-customer-checkout' }
    )
  )
);
